import type { ThemeType } from '../../../util/types';
import THEME from '../index';

export const APP_THEME: ThemeType = {
  colors: {
    ...THEME.colors,
  },
  typography: {
    ...THEME.typography,
  },
  sizes: {
    ...THEME.sizes,
  },
  fonts: {
    ...THEME.fonts,
  },
  shadows: {
    ...THEME.shadows,
  },
  radius: {
    ...THEME.radius,
  },
};
